export const subHeaderData = [
  {
    name: 'Grocery',
    linkName: 'Grocery',
    image:
      'https://rukminim1.flixcart.com/flap/128/128/image/29327f40e9c4d26b.png?q=100',
  },
  {
    name: 'Mobile',
    linkName: 'mobile',
    image:
      'https://rukminim1.flixcart.com/flap/128/128/image/22fddf3c7da4c4f4.png?q=100',
  },
  {
    name: 'Home',
    linkName: 'home',
    image:
      'https://rukminim1.flixcart.com/flap/128/128/image/ee162bad964c46ae.png?q=100',
  },
  {
    name: 'Appliance',
    linkName: 'appliance',
    image:
      'https://rukminim1.flixcart.com/flap/128/128/image/0ff199d1bd27eb98.png?q=100',
  },
  {
    name: 'Babycare',
    linkName: 'babycare',
    image:
      'https://rukminim1.flixcart.com/flap/128/128/image/dff3f7adcf3a90c6.png?q=100',
  },
  {
    name: 'Beauty',
    linkName: 'beauty',
    image:
      'https://i.pinimg.com/736x/6c/ab/93/6cab93a7cdb23d2b7bd8920f6cf2eb51.jpg',
  },
  {
    name: 'Sports',
    linkName: 'sports',
    image:
      'https://www.shutterstock.com/image-vector/sports-equipment-background-sport-concept-260nw-1917840683.jpg',
  },
  {
    name: 'Top Offers',
    linkName: 'topoffers',
    image:
      'https://rukminim1.flixcart.com/flap/128/128/image/f15c02bfeb02d15d.png?q=100',
  },
];
